<template>
  <a :class="badgeClass" :href="href" :target="target" @click.prevent.stop="goto">
    <font-awesome-icon :icon="icon" />

    {{
      invoiceNumber ? invoiceNumber.replace(/^0+/, "") : invoice.invoice_number.replace(/^0+/, "")
    }}

    <template v-if="showStatus">
      <template v-if="invoice.is_quote">
        {{ invoice.accepted_at ? "Accepted" : "" }}
      </template>
      <template v-else>
        {{ invoice.status }}
      </template>
    </template>

    <template v-if="openNew">
      <font-awesome-icon :icon="['fal', 'share-square']" />
    </template>
    <template v-else-if="entityId">
      <font-awesome-icon :icon="['fal', 'play']" />
    </template>
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    invoice: {
      type: Object,
    },
    invoiceNumber: {
      type: [Number, String],
    },
    entityId: {
      type: [Number, String],
    },
    showStatus: {
      type: Boolean,
      default: false,
    },
    openNew: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      icon: ["fal", "receipt"],
    };
  },

  computed: {
    href() {
      return this.entityId ? `/invoices/${this.entityId}/edit` : false;
    },
    target() {
      return this.entityId && this.openNew ? "_blank" : false;
    },
    badgeClass() {
      return `badge badge-readable ${this.color} ${this.size} ${
        this.invoice.is_quote ? "badge-warning" : "badge-primary"
      }`;
    },
  },

  methods: {
    goto() {
      if (!this.entityId) {
        return;
      }

      if (this.openNew) {
        window.open(this.href);
      } else {
        this.$router.push({
          name: "invoices.edit",
          params: { id: this.entityId },
        });
      }
    },
  },
};
</script>
